export class RiskAnalytics {
	private _upsideCapture: string;
	private _downsideCapture: string;
	// VAR value is not currently in use; keeping it until we clarify requirements
	private _varValue: string;
	private _sharpeRatio: string;
	private _sharpeRatio3Yr: string;
	private _sharpeRatio5Yr: string;
	private _riskContributionMap: Map<string, string>;
	private _riskContributionObject: Array<any>;
	private _standardDeviation1Yr: string;
	private _standardDeviation3Yr: string;
	private _standardDeviation5Yr: string;
	private _riskAsOfDateMap: Map<string, Date>;
	private _riskAsOfDateObject: Array<any>;

	public get upsideCapture(): string {
		return this._upsideCapture;
	}

	public set upsideCapture(value: string) {
		this._upsideCapture = value;
	}

	public get downsideCapture(): string {
		return this._downsideCapture;
	}

	public set downsideCapture(value: string) {
		this._downsideCapture = value;
	}

	public get varValue(): string {
		return this._varValue;
	}

	public set varValue(value: string) {
		this._varValue = value;
	}

	public get sharpeRatio(): string {
		return this._sharpeRatio;
	}

	public set sharpeRatio(value: string) {
		this._sharpeRatio = value;
	}

	public get sharpeRatio3Yr(): string {
		return this._sharpeRatio3Yr;
	}

	public set sharpeRatio3Yr(value: string) {
		this._sharpeRatio3Yr = value;
	}

	public get sharpeRatio5Yr(): string {
		return this._sharpeRatio5Yr;
	}

	public set sharpeRatio5Yr(value: string) {
		this._sharpeRatio5Yr = value;
	}

	public get riskContributionMap(): Map<string, string> {
		return this._riskContributionMap;
	}

	public set riskContributionMap(value: Map<string, string>) {
		this._riskContributionMap = value;
	}

	public get riskContributionObject(): any {
		return this._riskContributionObject;
	}

	public set riskContributionObject(value: any) {
		this._riskContributionObject = value ? [Array.from(value.keys()), Array.from(value.values())] : [];
	}

	public get standardDeviation1Yr(): string {
		return this._standardDeviation1Yr;
	}

	public set standardDeviation1Yr(value: string) {
		this._standardDeviation1Yr = value;
	}

	public get standardDeviation3Yr(): string {
		return this._standardDeviation3Yr;
	}

	public set standardDeviation3Yr(value: string) {
		this._standardDeviation3Yr = value;
	}

	public get standardDeviation5Yr(): string {
		return this._standardDeviation5Yr;
	}

	public set standardDeviation5Yr(value: string) {
		this._standardDeviation5Yr = value;
	}

	public get riskAsOfDateMap(): Map<string, Date> {
		return this._riskAsOfDateMap;
	}

	public set riskAsOfDateMap(value: Map<string, Date>) {
		this._riskAsOfDateMap = value ? value : new Map<string, Date>();
	}

	public get riskAsOfDateObject(): any {
		return this._riskAsOfDateObject;
	}

	public set riskAsOfDateObject(value: any) {
		this._riskAsOfDateObject = value ? [Array.from(value.keys()), Array.from(value.values())] : [];
	}

	public toString(): any {
		const riskAnalyticsObj = {};
		Object.keys(this).forEach(property => {
			if (this[property] instanceof Map) {
				const mapObj = {};
				this[property].forEach((value, key) => { mapObj[key] = value; });
				riskAnalyticsObj[property] = mapObj;
			} else if (this[property] instanceof Array) {
				const arrayObj = [];
				this[property].forEach(element => {
					const innerArray = [];
					if (element instanceof Array) {
						element.forEach(value => {
							if (value instanceof Date) {
								value = (value.getMonth() + 1) + '/' + value.getDate() + '/' + value.getFullYear();
							}
							innerArray.push(value);
						});
						arrayObj.push(innerArray);
					} else {
						if (element instanceof Date) {
							element = (element.getMonth() + 1) + '/' + element.getDate() + '/' + element.getFullYear();
						}
						arrayObj.push(element);
					}

				});
				riskAnalyticsObj[property] = arrayObj;
			} else {
				riskAnalyticsObj[property] = this[property];
			}
		});
		return riskAnalyticsObj;
	}
}
